import { Rule } from "./rule";

export type Logic = {
    fieldId: string; // This is the id of the field that the logic is applied to
    defaultTargetId: string; // This is the id of the field that the logic will default to if no rules are met
    branches: Branch[];
};

export type Branch = {
    id: string;
    name: string;
    targetId: string; // This is the id of the field that the logic will redirect to if the rules are met
    groups: Group[];
};

export type Group = {
    id: string;
    name: string;
    rules: Rule[];
};
``;
export enum OPERATOR {
    ALWAYS = "always",
    EQUAL = "equal",
    REGEX = "regex",
    CONTAINS = "contains",
    EXISTS = "is_not_empty",
    ENDS_WITH = "ends_with",
    STARTS_WITH = "starts_with",
    LESS_THAN = "less_than",
    GREATER_THAN = "greater_than",
    CONTAINS_WITHIN = "contains_within",
    LESS_THAN_OR_EQUAL = "less_than_or_equal",
    GREATER_THAN_OR_EQUAL = "greater_than_or_equal",

    NOT_EQUAL = "not_equal",
    NOT_EXISTS = "is_empty",
    NOT_CONTAINS = "not_contains",
    NOT_CONTAINS_WITHIN = "not_contains_within",
}
